import { render, staticRenderFns } from "./exchange-management.vue?vue&type=template&id=46bd6f72"
import script from "./exchange-management.vue?vue&type=script&lang=js"
export * from "./exchange-management.vue?vue&type=script&lang=js"
import style0 from "./exchange-management.vue?vue&type=style&index=0&id=46bd6f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports